// @flow

/**
* Creates a boolean reducer that will return true if the action type is in the
* trueTypes or false if it is in the falseTypes.
* @param defaultState - Default of the reducer that is set on app init
* @param trueTypes - List of types to return true
* @param falseTypes - List of types that ruturn false
* @returns {Function} - Reducer
*/
const booleanReducer = ({
  defaultState,
  trueTypes = [],
  falseTypes = [],
}: {
  defaultState: boolean,
  trueTypes: Array<String>,
  falseTypes: Array<String>,
}) => (state: ?boolean = defaultState, { type }: { type: string }) => {
  if (trueTypes.find(item => item === type)) {
    return true
  }
  if (falseTypes.find(item => item === type)) {
    return false
  }
  return state
}

export default booleanReducer



// WEBPACK FOOTER //
// ./src/utils/booleanReducer.js